<template>
  <button
    v-if="!href"
    :class="`btn ${theme}`"
    :type="type"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
  <a
    v-else-if="href"
    :class="`btn ${theme}`"
    :href="href"
    @click="$emit('click')"
    v-smooth-scroll
  >
    <slot></slot>
  </a>
  <a
    v-else
    :class="`btn ${theme}`"
    :disabled="disabled"
    :href="href"
    @click="$emit('click')"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'cta'
    },
    href: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  @include font('primary', 'bold');
  @include padding(17px 20px 15px);
  position: relative;
  display: inline-block;
  border: 1px solid $primary;
  border-radius: 24px;
  outline: none;
  background-color: $primary;
  color: $tertiary;
  font-size: rem(12px);
  line-height: 1;
  text-align: center;
  text-transform: uppercase;

  &[disabled] {
    opacity: .3;
  }

  .svg {
    @include position(absolute, 50% 20px null null);
    fill: $secondary;
    transform: translateY(-50%);
  }

  &.blue {
    background-color: $fb-blue;
    border-color: $fb-blue;
    color: $white;
    .svg {
      fill: $white;
    }
  }

  &.tertiary {
    background-color: $tertiary;
    border-color: $tertiary;
    color: $primary;

    .svg {
      fill: $primary;
      &.arrow-right {
        fill: $secondary;
      }
    }
  }

  &.transparent {
    background-color: transparent;
    border-color: $white;
    color: $white;
    font-size: rem(10px);

    .svg {
      fill: $white;
    }

    &--secondary {
      .svg {
        fill: $secondary;
      }
    }
  }

  &.ghost {
    @include padding(11px 20px 9px);
    background-color: rgba($white, .75);
    backdrop-filter: blur(20px);
    border: none;
    color: $primary;
    font-size: rem(10px);
  }

  // &.small {
  //   @include font('secondary', 'regular');
  //   @include padding(11px 0);
  //   width: 100%;
  //   border-color: rgba($tertiary, .4);
  //   border-radius: 0;
  //   border-top: none;
  //   border-left: none;
  //   border-right: none;
  //   color: $tertiary;
  //   font-size: rem(9px);
  //   text-align: left;
  //   .svg {
  //     right: 0;
  //   }
  // }

  &.link {
    @include padding(5px 14px);
    background-color: transparent;
    border: none;
    color: $white;
    text-decoration: underline;
    text-transform: none;

    &-small {
      @include padding(5px 0);
      @include font('primary', 'regular');
      color: rgba($tertiary, .5);
      font-size: rem(9px);
    }
  }

  &.text {
    @include padding(0);
    @include font('primary', 'bold');
    display: inline-block;
    width: auto;
    background-color: transparent;
    border: none;
    color: $secondary;
    text-transform: initial;
  }
}
</style>
